export const toFixedNum = (num = 0.0, limit = 2) => Number(num.toFixed(limit))
